export default "__VITE_ASSET__BkU3BdGr__"